module.exports = __webpack_public_path__ + "img/battery_1classic.0a4f7c26.png";